export default __webpack_public_path__ + "3de5adddd64ddb57f52a830c13dccebc.svg";